// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G8d8","name":"styles_name__3QDwU","phone":"styles_phone__3BjLq"};